import '../style/table-CEO9cfIE.css'
import { ref as B, watch as ne, computed as u, toRef as be, onMounted as we, reactive as $e, defineComponent as j, toRefs as ye, withDirectives as xe, openBlock as i, createElementBlock as g, unref as t, normalizeClass as I, normalizeStyle as D, renderSlot as E, createVNode as T, withModifiers as Re, Fragment as P, renderList as N, createElementVNode as R, createBlock as z, mergeProps as ee, createCommentVNode as V, withCtx as se, createTextVNode as Le, toDisplayString as He, isRef as de, createSlots as Pe, normalizeProps as ze, guardReactiveProps as Me } from "vue";
import { Checkbox as pe } from "./checkbox.js";
import Ve from "./pagination.js";
import Ee from "./internalComponents/defaultHeaderSlot.js";
import Be from "./internalComponents/Empty.js";
import { DEFAULT_LIST_ITEM_HEIGHT as De } from "./constant/list.js";
import Te from "./internalComponents/MobileDetail.js";
import { useListSkeleton as We } from "./hooks/useListSkeleton.js";
import { useEventDelegation as Ge } from "./hooks/useEventDelegation.js";
import { useStorage as Oe, useResizeObserver as Ie, useEventListener as Ne } from "@vueuse/core";
import { useBorderBoxElementSize as me } from "./hooks/useBorderBoxElementSize.js";
import { useSort as Fe } from "./hooks/useSort.js";
import { useVisibleSize as Ue } from "./hooks/useVisibleSize.js";
import { getInnerVirtualScroll as Ae, setListCSSVariables as fe } from "./utils/list.js";
import { useMobileView as je } from "./hooks/useMobileView.js";
import { useElementBreakpoint as Ke } from "./hooks/useElementBreakpoint.js";
import { pxlize as he } from "x-utils";
import { getColumnClassStyle as Xe, ListComponentTypeEnum as qe } from "./utils/listColumn.js";
import Je from "./directives/ripple.js";
import Qe from "./internalComponents/SortIcon.js";
import Ye from "./icon.js";
import Ze from "./cell-list.js";
import ve from "./spinner.js";
import et, { SkeletonGrid as tt } from "./skeleton.js";
function lt(s) {
  const { body: o, isMobile: e, rows: l, emit: r } = s, c = B(!1), h = B(), d = B(-1);
  return ne(l, () => {
    c.value && d.value !== -1 && (h.value = l.value[d.value]);
  }), Ge({
    element: o,
    eventListeners: [
      {
        eventName: "mouseover",
        selector: "tr",
        handler: (y) => {
          const n = y.dataset.rowIndex;
          if (n) {
            const a = l.value[+n];
            r("hover", a, +n);
          }
        }
      },
      {
        eventName: "mouseleave",
        handler: () => {
          r("hover", null, -1);
        }
      },
      {
        eventName: "click",
        selector: "tr",
        handler: (y) => {
          const n = y.dataset.rowIndex;
          if (n) {
            const a = +n, f = l.value[a];
            e.value && (c.value = !0), h.value = f, d.value = a, r("row-click", f, a);
          }
        }
      }
    ]
  }), {
    isShowDetail: c,
    detailRow: h
  };
}
function ot(s) {
  const { pagination: o, rows: e } = s, l = B(1), r = u(() => e.value.length);
  o && ne(r, () => {
    l.value * o.pageSize > r.value && (l.value = 1);
  });
  const c = u(() => o ? {
    ...o,
    hasNext: r.value > l.value * o.pageSize,
    total: r.value
  } : !1);
  return {
    page: l,
    tablePagination: c
  };
}
function st(s, o) {
  const { responsiveOptions: e } = o, { isMobile: l } = e?.self ? Ke(s, { self: !0 }, e.breakpoints) : je(), r = u(() => o.responsiveLayout === "scroll"), c = u(() => (o.responsiveLayout === "card" || o.responsiveOptions?.layout === "card") && l.value);
  return {
    isResponsiveScrollMode: r,
    isResponsiveCardMode: c,
    isMobile: l
  };
}
function nt(s) {
  const { fixedHeader: o, horizontalScroll: e, isVirtual: l, fixedColumn: r, isResponsiveScrollMode: c } = s, h = u(() => l.value || !!o), d = u(() => r.value || e || c.value), y = u(() => {
    const n = [];
    return (h.value || d.value) && (n.push("e-scroller e-scroller--fat"), d.value && n.push("e-scroller--horizontal")), n;
  });
  return {
    isVerticalScrollable: h,
    isHorizontalScrollable: d,
    scrollerClassList: y
  };
}
function rt(s, o, e, l) {
  const { theme: r, rowGap: c, fixedHeader: h, columns: d, presort: y, sortingCacheId: n } = e;
  let a = y;
  const f = Oe("x-ui.table.sorting", {});
  n && f && (a = f.value[n]);
  let k = null;
  a && a.sortProp && (k = d.find((b) => b.sortProp === a?.sortProp)?.sortType || null);
  const { sortProp: m, sortDirection: C, sortHandler: W, sortedRows: S } = Fe(l, a, k), { isResponsiveScrollMode: $, isResponsiveCardMode: _, isMobile: w } = st(s, {
    responsiveLayout: e.responsiveLayout,
    responsiveOptions: e.responsiveOptions
  }), { height: F } = me(s), { height: L } = me(o, { width: 0, height: e.headerHeight ?? 0 }), U = Ae(s, e.virtualScroll, L), x = be(e, "itemHeight"), K = u(
    () => e.itemHeight !== void 0 && e.rowGap !== void 0 ? e.itemHeight + e.rowGap : 0
  ), X = u(() => F.value), te = u(() => ({
    rowGap: e.rowGap,
    itemHeight: e.itemHeight,
    headerHeight: e.headerHeight
  }));
  ne(te, (b) => {
    fe(s.value, b);
  }, { deep: !0 }), ne([m, C], ([b, q]) => {
    n && (f.value = {
      ...f.value,
      [n]: {
        sortProp: b,
        sortDirection: q
      }
    });
  });
  const le = u(() => X.value && L ? Math.max(X.value - L.value, 0) : 0), Q = u(() => d.some((b) => b.fixed)), Y = u(() => !!U), { isVerticalScrollable: A, scrollerClassList: re } = nt({
    fixedHeader: h,
    horizontalScroll: e.horizontalScroll,
    isVirtual: Y,
    fixedColumn: Q,
    isResponsiveScrollMode: $
  }), ae = u(() => {
    const b = {};
    return c && (b.borderSpacing = "0 var(--list-row-gap)", b.borderCollapse = "separate"), e.tableLayout && (b.tableLayout = e.tableLayout), b;
  }), ie = u(() => {
    const b = [
      "e-table-wrapper",
      ...re.value,
      {
        "e-table-wrapper--bordered": e.isBordered,
        "e-table-wrapper--card": _.value
      }
    ];
    return r && b.push(`e-theme--${r}`), b;
  }), G = u(() => {
    const b = {};
    return _.value && (b.display = "none"), Y.value && (b.height = L.value + "px"), b;
  }), H = Ue(le, K);
  return we(() => {
    fe(s.value, te.value);
  }), {
    height: X,
    headerHeight: L,
    bodyHeight: le,
    itemHeight: x,
    itemHeightWithGap: K,
    wrapperClass: ie,
    tableStyle: ae,
    headerStyle: G,
    visibleSize: H,
    virtualScroll: U,
    fixedColumn: Q,
    isVirtual: Y,
    isVerticalScrollable: A,
    isMobile: w,
    isResponsiveScrollMode: $,
    isResponsiveCardMode: _,
    sortProp: m,
    sortDirection: C,
    columnHandlers: [W],
    rows: S
  };
}
function at(s, o) {
  let e = !0, l = !1, r = 0, c = 0;
  const h = [], [d, y] = s.reduce((n, a, f) => {
    if (a.fixed) {
      const k = s[f - 1], m = s[f + 1], C = parseFloat(a.width);
      k && !k.fixed && (e = !1, l = !0), e && (n[0].push({
        index: f,
        class: o ? "e-fixed-left" : "",
        isLeftLast: !m?.fixed,
        style: {
          left: r + "px",
          minWidth: he(a.width)
        }
      }), r += C), l && (h.push(C), n[1].push({
        index: f,
        class: o ? "e-fixed-right" : "",
        isRightFirst: !n[1].length,
        style: {
          minWidth: he(a.width)
        }
      }), c += C), m && !m.fixed && (e = !1, l = !0);
    }
    return n;
  }, [[], []]);
  return y.forEach((n, a) => {
    c -= h[a], n.style.right = c + "px";
  }), [...d, ...y].reduce((n, a) => (n.set(a.index, a), n), /* @__PURE__ */ new Map());
}
function it({
  container: s,
  table: o,
  columns: e,
  isMobile: l,
  mobileColumns: r,
  sortColumn: c,
  fixedColumn: h,
  columnHandlers: d
}) {
  const y = $e({
    pingLeft: !1,
    pingRight: !1
  }), n = B(!1);
  Ie(s, () => {
    n.value = s.value?.clientWidth < o.value?.clientWidth;
  });
  const a = u(() => {
    const m = e.value, C = at(m, n.value);
    return m.map((S, $) => {
      let { headerClass: _, bodyClass: w, headerStyle: F, bodyStyle: L } = Xe(S, qe.Table);
      S.sortable && (S.sortProp = S.sortProp || S.prop), S.sortProp && S.sortProp === c.value && _.push("e-table-column-header--highlight"), S.align && (_.push(`align-${S.align}`), w.push(`align-${S.align}`));
      const U = {};
      d.length && (U.onClick = () => {
        d.forEach((K) => {
          K(S);
        });
      });
      const x = C.get($);
      return x && (_.push(x.class, "e-table-column-header--fixed"), w.push(x.class), F = { ...F, ...x.style }, L = { ...L, ...x.style }, y.pingLeft && x.isLeftLast && (_.push("ping-left"), w.push("ping-left")), y.pingRight && x.isRightFirst && (_.push("ping-right"), w.push("ping-right"))), {
        ...S,
        attributes: U,
        _headerClass: _,
        _bodyClass: w,
        _headerStyle: F,
        _bodyStyle: L
      };
    });
  }), f = u(() => l.value && r.value ? r.value : a.value.filter((m) => m.type !== "selection")), k = u(() => a.value.find((m) => m.type === "selection"));
  return Ne(s, "scroll", (m) => {
    if (h && h.value) {
      const { scrollLeft: C, clientWidth: W } = m.target, S = o.value.clientWidth;
      y.pingLeft = C > 0, y.pingRight = C < S - W;
    }
  }), {
    selectionColumn: k,
    computedColumns: f
  };
}
function ut(s, o, e) {
  const l = u(() => s.value.filter((n) => n._selected).length), r = u(() => {
    const { max: n } = o, a = Math.min(s.value.length, n ?? Number.MAX_SAFE_INTEGER);
    return a > 0 && l.value === a;
  });
  function c() {
    const { max: n } = o, a = l.value;
    n && (a >= n ? h() : s.value.forEach((f) => {
      f._selectionDisabled = !1;
    })), d();
  }
  function h() {
    s.value.forEach((n) => {
      n._selected || (n._selectionDisabled = !0);
    });
  }
  function d() {
    e("selected", s.value.filter((n) => n._selected));
  }
  function y(n) {
    const { max: a } = o;
    let f = l.value, k = !1;
    if (n)
      for (const m of s.value) {
        if (a && f >= a) {
          h();
          break;
        }
        m._selected || (m._selected = !0, k = !0, f++);
      }
    else
      for (const m of s.value)
        m._selected = !1, m._selectionDisabled = !1, k = !0;
    k && d();
  }
  return {
    isSelectAll: r,
    toggleSelectAll: y,
    updateSelectionStatus: c
  };
}
function ct(s, o, e, l, r, c) {
  if (!l)
    return {
      virtualRows: o,
      virtualPadding: { top: 0, bottom: 0 }
    };
  const { rowGap: h, renderPages: d, scrollTop: y } = l, n = u(() => c.value + h.value), a = u(() => Math.min(e.ceilSize * d.value, f.value)), f = u(() => o.value.length), k = u(() => {
    const _ = f.value * n.value + r.value;
    return Math.max(_ - n.value * a.value - r.value, 0);
  }), m = u(() => {
    const $ = Math.floor(y.value / n.value), _ = d.value > 1 ? a.value / (d.value + 1) : 0;
    let w = Math.max(Math.floor($ - _), 0);
    return w + a.value > f.value && (w = f.value - a.value), w;
  }), C = u(() => m.value + a.value), W = u(() => {
    let $ = m.value * n.value, _ = k.value - $;
    return _ < n.value && (_ = 0, $ = k.value), { top: $, bottom: _ };
  });
  return {
    virtualRows: u(() => o.value.slice(m.value, C.value)),
    virtualPadding: W
  };
}
function dt(s, o) {
  if (s && Object.keys(s).length && o) {
    if (o.indexOf(".") === -1)
      return s[o];
    {
      const e = o.split(".");
      let l = s;
      for (let r = 0, c = e.length; r < c; ++r) {
        if (l == null)
          return null;
        l = l[e[r]];
      }
      return l;
    }
  } else
    return null;
}
function pt(s, o, e) {
  const l = ["e-table-row"];
  return s.$options?.class && l.push(s.$options.class), o && s.$options?.expandable !== !1 && l.push("e-table-row--expandable"), s._expanded && (l.push("e-table-row--expanded"), e && l.push("e-table-row--borderless")), l;
}
function mt(s, o, e) {
  return s ? dt(o, s) : e;
}
const ft = ["aria-sort"], ht = /* @__PURE__ */ j({
  __name: "table-column",
  props: {
    sortProp: {},
    sortDirection: {},
    column: {}
  },
  setup(s) {
    const o = s, { column: e, sortProp: l } = ye(o);
    return (r, c) => xe((i(), g("th", {
      key: t(e).prop,
      class: I(t(e)._headerClass),
      style: D(t(e)._headerStyle),
      "aria-sort": t(e).sortProp ? t(l) === t(e).sortProp ? r.sortDirection : "none" : void 0
    }, [
      E(r.$slots, "default"),
      T(Qe, {
        column: t(e),
        "sort-prop": t(l),
        "sort-direction": r.sortDirection
      }, null, 8, ["column", "sort-prop", "sort-direction"])
    ], 14, ft)), [
      [t(Je), t(e).sortable]
    ]);
  }
}), vt = {
  key: 1,
  class: "e-expandable-cell"
}, gt = /* @__PURE__ */ j({
  __name: "table-cell",
  props: {
    row: {},
    column: {}
  },
  emits: ["expand"],
  setup(s, { emit: o }) {
    const e = o, l = () => {
      e("expand");
    };
    return (r, c) => (i(), g("td", {
      class: I(r.column._bodyClass),
      style: D(r.column._bodyStyle)
    }, [
      !r.column.expandable || r.row.$options?.expandable === !1 ? E(r.$slots, "default", { key: 0 }) : (i(), g("div", vt, [
        E(r.$slots, "default"),
        T(t(Ye), {
          icon: "caret-down",
          rotation: r.row._expanded ? 180 : 0,
          onClick: Re(l, ["stop"])
        }, null, 8, ["rotation"])
      ]))
    ], 6));
  }
}), bt = /* @__PURE__ */ j({
  __name: "table-cell-card",
  props: {
    row: {},
    columns: {}
  },
  emits: ["expand"],
  setup(s) {
    return (o, e) => (i(!0), g(P, null, N(o.columns, (l) => (i(), g("td", {
      key: l.prop
    }, [
      T(t(Ze), {
        data: [{ label: l.title, value: o.row[l.prop] }],
        "is-bordered": !1
      }, null, 8, ["data"])
    ]))), 128));
  }
}), yt = { class: "e-virtual-scroll__padding" }, _t = ["colspan"], ge = /* @__PURE__ */ j({
  __name: "virtualPadding",
  props: {
    height: { default: 0 },
    colspan: {}
  },
  setup(s) {
    const o = s;
    return (e, l) => (i(), g("tbody", yt, [
      R("tr", null, [
        R("td", {
          colspan: e.colspan,
          style: D({ height: `${o.height}px` })
        }, null, 12, _t)
      ])
    ]));
  }
}), St = {
  key: 0,
  class: "e-table--loading"
}, kt = { colspan: 99 }, Ct = {
  key: 1,
  class: "e-table--loading"
}, wt = /* @__PURE__ */ j({
  __name: "loading",
  props: {
    isEmpty: { type: Boolean },
    skeleton: {},
    computedColumns: {}
  },
  setup(s) {
    const e = be(s, "skeleton");
    return (l, r) => e.value ? (i(!0), g(P, { key: 0 }, N(e.value.numberOfRows, (c) => (i(), g("tr", {
      key: c,
      style: D({ height: e.value.rowHeight })
    }, [
      (i(!0), g(P, null, N(l.computedColumns, (h, d) => (i(), g("td", {
        key: h.prop,
        class: I(h._bodyClass),
        style: D(h._bodyStyle)
      }, [
        e.value?.columns?.[d]?.type === "grid" ? (i(), z(t(tt), ee({
          key: 0,
          ref_for: !0
        }, e.value?.columns?.[d].props), null, 16)) : (i(), z(t(et), ee({
          key: 1,
          ref_for: !0
        }, e.value?.columns?.[d]), null, 16))
      ], 6))), 128))
    ], 4))), 128)) : (i(), g(P, { key: 1 }, [
      l.isEmpty ? (i(), g("tr", St, [
        R("td", kt, [
          T(t(ve), {
            size: 30,
            "stroke-width": "3"
          })
        ])
      ])) : (i(), g("div", Ct, [
        T(t(ve), {
          size: 30,
          "stroke-width": "3"
        })
      ]))
    ], 64));
  }
}), $t = ["data-row-index"], xt = {
  key: 0,
  class: "e-table-sub-row"
}, Rt = ["colspan"], Zt = /* @__PURE__ */ j({
  name: "e-table",
  __name: "table",
  props: {
    isBordered: { type: Boolean, default: !0 },
    loading: { type: Boolean, default: !1 },
    skeleton: { type: [Object, Boolean] },
    responsiveLayout: { default: "scroll" },
    responsiveOptions: {},
    fixedHeader: { type: Boolean, default: !1 },
    headerHeight: {},
    itemHeight: { default: De },
    emptyHeight: {},
    horizontalScroll: { type: Boolean },
    tableLayout: {},
    source: { default: () => [] },
    columns: { default: () => [] },
    mobileColumns: {},
    selection: { default: () => ({}) },
    presort: { default: () => ({
      sortProp: null,
      sortDirection: null
    }) },
    dataKey: {},
    expandedBorderless: { type: Boolean },
    subRowDataKey: {},
    subColumns: {},
    rowGap: { default: 0 },
    theme: {},
    virtualScroll: { type: [Object, null, Boolean] },
    pagination: {},
    detailModalProps: {},
    sortingCacheId: {}
  },
  emits: ["row-mouse-enter", "row-mouse-leave", "hover", "row-click", "sorted", "expanded", "selected"],
  setup(s, { emit: o }) {
    const e = s, l = o, { selection: r, expandedBorderless: c } = e, { source: h, columns: d, mobileColumns: y, skeleton: n } = ye(e), a = B(), f = B(), k = B(), m = B(), C = u(() => d.value.some((v) => v.expandable)), {
      tableStyle: W,
      headerStyle: S,
      visibleSize: $,
      wrapperClass: _,
      isVirtual: w,
      virtualScroll: F,
      isVerticalScrollable: L,
      fixedColumn: U,
      isMobile: x,
      isResponsiveCardMode: K,
      itemHeight: X,
      headerHeight: te,
      columnHandlers: le,
      sortProp: Q,
      sortDirection: Y,
      rows: A
    } = rt(a, f, e, h), {
      isSelectAll: re,
      toggleSelectAll: ae,
      updateSelectionStatus: ie
    } = ut(A, r, l), {
      selectionColumn: G,
      computedColumns: H
    } = it({
      container: a,
      table: k,
      columns: d,
      mobileColumns: y,
      isMobile: x,
      sortColumn: Q,
      fixedColumn: U,
      columnHandlers: le
    }), b = We({
      skeleton: n,
      columns: H,
      scrollable: L,
      visibleSize: $,
      itemHeight: X,
      pagination: e.pagination
    }), { tablePagination: q, page: Z } = ot({
      pagination: e.pagination,
      rows: A
    }), {
      virtualRows: _e,
      virtualPadding: ce
    } = ct(a, A, $, F, te, X), oe = u(() => {
      if (w.value)
        return _e.value;
      if (q.value) {
        const { pageSize: v } = q.value;
        return A.value.slice(Z.value * v - v, Z.value * v);
      }
      return A.value;
    }), Se = u(() => !(e.loading && b.value)), { isShowDetail: ue, detailRow: ke } = lt({
      body: m,
      isMobile: x,
      rows: oe,
      emit: l
    }), Ce = (v, J) => {
      v._expanded = !v._expanded, l("expanded", v, J, v._expanded);
    };
    return (v, J) => (i(), g(P, null, [
      R("div", ee({
        ref_key: "wrapper",
        ref: a,
        class: t(_)
      }, v.$attrs), [
        R("table", {
          ref_key: "table",
          ref: k,
          class: "e-table",
          style: D(t(W))
        }, [
          R("colgroup", null, [
            (i(!0), g(P, null, N(t(H), (p) => (i(), g("col", {
              key: p.prop,
              class: I(`col-${p.prop}`)
            }, null, 2))), 128))
          ]),
          R("thead", {
            ref_key: "header",
            ref: f,
            class: I(["e-table-head", { "e-thead-sticky": t(L) }]),
            style: D(t(S))
          }, [
            R("tr", null, [
              t(G) ? (i(), g("th", {
                key: 0,
                class: I([t(G)._headerClass, "e-table-column"]),
                style: D(t(G)._headerStyle)
              }, [
                T(t(pe), {
                  "model-value": t(re),
                  "onUpdate:modelValue": t(ae)
                }, null, 8, ["model-value", "onUpdate:modelValue"])
              ], 6)) : V("", !0),
              (i(!0), g(P, null, N(t(H), (p) => (i(), z(ht, ee({
                key: p.prop,
                column: p,
                "sort-prop": t(Q),
                "sort-direction": t(Y),
                ref_for: !0
              }, p.attributes), {
                default: se(() => [
                  E(v.$slots, `header-${p.prop}`, { col: p }, () => [
                    T(Ee, {
                      title: p.title,
                      tooltip: p.tooltip
                    }, null, 8, ["title", "tooltip"])
                  ])
                ]),
                _: 2
              }, 1040, ["column", "sort-prop", "sort-direction"]))), 128))
            ])
          ], 6),
          t(w) ? (i(), z(ge, {
            key: 0,
            height: t(ce).top,
            colspan: t(H).length
          }, null, 8, ["height", "colspan"])) : V("", !0),
          R("tbody", {
            ref_key: "body",
            ref: m,
            class: "e-table-body"
          }, [
            v.loading ? (i(), z(wt, {
              key: 0,
              skeleton: t(b),
              "is-empty": !oe.value.length,
              "computed-columns": t(H)
            }, null, 8, ["skeleton", "is-empty", "computed-columns"])) : oe.value.length ? V("", !0) : (i(), z(Be, {
              key: 1,
              variant: "table",
              height: v.emptyHeight,
              "is-small": t(x)
            }, {
              default: se(() => [
                E(v.$slots, "empty")
              ]),
              _: 3
            }, 8, ["height", "is-small"])),
            Se.value ? (i(!0), g(P, { key: 2 }, N(oe.value, (p, M) => (i(), g(P, {
              key: t(mt)(v.dataKey, p, M)
            }, [
              R("tr", {
                class: I(t(pt)(p, C.value, t(c))),
                "data-row-index": M
              }, [
                t(G) ? (i(), g("td", {
                  key: 0,
                  class: I(["e-selection", t(G)._bodyClass]),
                  style: D(t(G)._bodyStyle)
                }, [
                  T(t(pe), {
                    modelValue: p._selected,
                    "onUpdate:modelValue": [(O) => p._selected = O, t(ie)],
                    disabled: p._selectionDisabled
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                ], 6)) : V("", !0),
                t(K) ? E(v.$slots, "$row-card", {
                  key: 1,
                  row: p,
                  index: M,
                  columns: t(H)
                }, () => [
                  T(bt, {
                    columns: t(H),
                    row: p
                  }, null, 8, ["columns", "row"])
                ]) : (i(!0), g(P, { key: 2 }, N(t(H), (O) => (i(), z(gt, {
                  key: O.prop,
                  row: p,
                  column: O,
                  onExpand: (Lt) => Ce(p, M)
                }, {
                  default: se(() => [
                    E(v.$slots, O.prop, {
                      row: p,
                      index: M
                    }, () => [
                      Le(He(p[O.prop]), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["row", "column", "onExpand"]))), 128))
              ], 10, $t),
              p._expanded ? (i(), g("tr", xt, [
                R("td", {
                  colspan: t(H).length
                }, [
                  E(v.$slots, "expand", {
                    row: p,
                    index: M
                  })
                ], 8, Rt)
              ])) : V("", !0)
            ], 64))), 128)) : V("", !0)
          ], 512),
          t(w) ? (i(), z(ge, {
            key: 1,
            height: t(ce).bottom,
            colspan: t(H).length
          }, null, 8, ["height", "colspan"])) : V("", !0)
        ], 4),
        v.$slots.$detail ? (i(), z(Te, {
          key: 0,
          modelValue: t(ue),
          "onUpdate:modelValue": J[0] || (J[0] = (p) => de(ue) ? ue.value = p : null),
          row: t(ke),
          columns: t(d),
          "is-mobile": t(x),
          "modal-props": v.detailModalProps
        }, Pe({ _: 2 }, [
          N(v.$slots, (p, M) => ({
            name: M,
            fn: se((O) => [
              E(v.$slots, M, ze(Me(O)))
            ])
          }))
        ]), 1032, ["modelValue", "row", "columns", "is-mobile", "modal-props"])) : V("", !0)
      ], 16),
      t(q) ? (i(), z(t(Ve), ee({
        key: 0,
        page: t(Z),
        "onUpdate:page": J[1] || (J[1] = (p) => de(Z) ? Z.value = p : null),
        class: "my-16"
      }, t(q)), null, 16, ["page"])) : V("", !0)
    ], 64));
  }
}), el = /* @__PURE__ */ j({
  name: "e-scrollbar-corner",
  __name: "scrollbar-corner",
  props: {
    size: { default: 4 },
    background: { default: "var(--bg-surface-1)" }
  },
  setup(s) {
    const o = s, e = {
      width: `${o.size}px`,
      height: `${o.size + 2}px`,
      background: o.background
    }, l = {
      width: `${o.size + 2}px`,
      height: `${o.size}px`,
      background: o.background
    };
    return (r, c) => (i(), g(P, null, [
      R("div", {
        class: "e-scrollbar-corner",
        style: e
      }),
      R("div", {
        class: "e-scrollbar-corner",
        style: l
      })
    ], 64));
  }
});
export {
  el as ScrollbarCorner,
  Zt as default
};
//# sourceMappingURL=table.js.map
